import { Text as NativeText } from 'react-native'

import { styled } from 'nativewind'

export const M16 = styled(NativeText, 'font-[JioType-Bold] text-[16px]')

export const M20 = styled(NativeText, 'font-[JioType-Black]  text-[20px]')

export const M14 = styled(NativeText,  'font-[JioType-Medium] text-[14px]')

export const B14 = styled(NativeText, 'font-[JioType] text-[14px]')
